/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HpRespTopHeroBannerImageItem_bannerItem = {
    readonly cmsId: number | null;
    readonly imageCopy: string | null;
    readonly imageUrl?: string | null;
    readonly imageHeight?: string | null;
    readonly imageWidth?: string | null;
    readonly mobileImageHeight?: string | null;
    readonly mobileImageWidth?: string | null;
    readonly mobileImageUrl?: string | null;
    readonly linkData: {
        readonly path: string | null;
    };
    readonly cta: string | null;
    readonly isFullBleedImage: boolean | null;
    readonly " $refType": "HpRespTopHeroBannerImageItem_bannerItem";
};
export type HpRespTopHeroBannerImageItem_bannerItem$data = HpRespTopHeroBannerImageItem_bannerItem;
export type HpRespTopHeroBannerImageItem_bannerItem$key = {
    readonly " $data"?: HpRespTopHeroBannerImageItem_bannerItem$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespTopHeroBannerImageItem_bannerItem">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "HpRespTopHeroBannerImageItem_bannerItem",
  "type": "TopHeroBannerItem",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isMobile",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "cmsId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "imageCopy",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "linkData",
      "storageKey": null,
      "args": null,
      "concreteType": "LinkData",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "path",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "cta",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isFullBleedImage",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "Condition",
      "passingValue": false,
      "condition": "isMobile",
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "imageUrl",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "imageHeight",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "imageWidth",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isMobile",
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "mobileImageHeight",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "mobileImageWidth",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "mobileImageUrl",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = 'e21d5adb004f659816a61ad3da79470e';
export default node;
